var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.60736 8.48832C7.25153 7.84064 4.74847 7.84064 2.39264 8.48832C0.979141 8.87552 0 10.1216 0 11.5366V13.1558C0 13.6698 0.434356 14.0922 0.971779 14.0922H11.0282C11.5656 14.0922 12 13.6698 12 13.1558V11.5366C12 10.1216 11.0209 8.87552 9.60736 8.48832Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00026 6.67356C7.65671 6.67356 9.00394 5.3782 9.00394 3.78716C9.00394 2.19612 7.65671 0.900757 6.00026 0.900757C4.34382 0.900757 2.99658 2.19612 2.99658 3.78716C2.99658 5.3782 4.33646 6.67356 6.00026 6.67356Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.285c3694f41ac3ff1c757c0c9f88898c.svg";
export { ForwardRef as ReactComponent };